/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SyncPatientMatchingCard/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Avatar from './Avatar/index'
import Dob from './Dob/index'
import Email from './Email/index'
import Error from './Error/index'
import FirstName from './FirstName/index'
import Gender from './Gender/index'
import HumanId from './HumanId/index'
import LastName from './LastName/index'
import Phone from './Phone/index'
import React from 'react'
import RemovePatient from './RemovePatient/index'
import ReplacePatient from './ReplacePatient/index'
import Selected from './Selected/index'
import Tag from './Tag/index'
import Zip from './Zip/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SyncPatientMatchingCard({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard"
  
}) {
let cardSelectedValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'selected',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="SyncPatientMatchingCard.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-2foAaw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-2foAaw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-2foAaw': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-2foAaw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-2foAaw': cardSelectedValueData ? dtColorsNeutral100 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<Selected
  viewPath={`${viewPath}/Selected`}
/>
<div
  data-testid="SyncPatientMatchingCard.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
/>
<div
  data-testid="SyncPatientMatchingCard.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="SyncPatientMatchingCard.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="SyncPatientMatchingCard.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-6-2foAaw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal3}`}
>
<FirstName
  viewPath={`${viewPath}/FirstName`}
/>
<LastName
  viewPath={`${viewPath}/LastName`}
/>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<Dob
  viewPath={`${viewPath}/Dob`}
/>
<Error
  viewPath={`${viewPath}/Error`}
/>
</div>
<div
  data-testid="SyncPatientMatchingCard.Horizontal:4"
  data-view-path={viewPath}
 style={{'--g-6-2foAaw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal4}`}
>
<ReplacePatient
  viewPath={`${viewPath}/ReplacePatient`}
/>
<RemovePatient
  viewPath={`${viewPath}/RemovePatient`}
/>
</div>
</div>
<div
  data-testid="SyncPatientMatchingCard.Horizontal:5"
  data-view-path={viewPath}
 style={{'--g-6-2foAaw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-7-2foAaw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal5}`}
>
<Email
  viewPath={`${viewPath}/Email`}
/>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
<HumanId
  viewPath={`${viewPath}/HumanId`}
/>
</div>
<div
  data-testid="SyncPatientMatchingCard.Horizontal:6"
  data-view-path={viewPath}
 style={{'--g-6-2foAaw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-7-2foAaw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal6}`}
>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
<Tag
  viewPath={`${viewPath}/Tag`}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}